import createPersistedState from 'use-persisted-state';
const useFavoritesState = createPersistedState('bottlebooks:favorites');

const initialState = [];

export default function useFavorites() {
  /** @type {[Favorites, (newFavorites:Favorites) =>void ]} */
  const [favorites, setFavorites] = useFavoritesState(initialState);

  return { isFavorite, favorites, toggleFavorite };

  /**
   * @param {string} id
   * @returns
   */
  function getFavorite(id) {
    return favorites?.find((favorite) => favorite.id === id);
  }
  /**
   * @param {string} id
   * @returns
   */
  function isFavorite(id) {
    return Boolean(getFavorite(id));
  }
  /**
   * @param {string} id
   * @param {Omit<Favorite, id>} [data] optional data to store
   * @returns
   */
  function toggleFavorite(id, data) {
    if (isFavorite(id)) {
      return setFavorites(favorites.filter((favorite) => favorite.id !== id));
    }
    return setFavorites([
      ...favorites,
      { ...data, id, addedAt: new Date().toISOString() },
    ]);
  }
}

/**
 * @typedef {object} Favorite
 * @property {string} id
 * @property {string} [name]
 * @property {FavoriteType} [type]
 * @property {string} [addedAt]
 */
/** @typedef {'product'| 'producer' | 'exhibitor'} FavoriteType */
/**  @typedef {Favorite[]} Favorites */
